// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import get from 'lodash/get';

import jsonParse from '../../utils/json';

export const getParsedGatewayDetails = (gatewayDetails) => ({
  ...gatewayDetails,
  tenantGatewayLogs : jsonParse(get(gatewayDetails, 'tenantGatewayLogs')),
});

export default () => {};
